import React, { useState, useEffect } from 'react';
import Axios from 'axios';
import { Link } from "react-router-dom";
import { host } from '../../App';
import './Schedule.css';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function ActivityLog() {
  const [activityLogs, setActivityLogs] = useState([]);
  const [filteredLogs, setFilteredLogs] = useState([]);
  const [Date1, setDate1] = useState(new Date());
  const [startDate, setStartDate] = useState(Date1.toISOString().slice(0, 10));
  const [endDate, setEndDate] = useState(Date1.toISOString().slice(0, 10));
  const [filterUser, setFilterUser] = useState('');
  const [filterAction, setFilterAction] = useState('');
  const [filterSRNo, setFilterSRNo] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [expandedRows, setExpandedRows] = useState({});
  const [users, setUsers] = useState([]);
  const token = window.localStorage.getItem("acessToken");

  // Fetch activity logs
  const fetchActivityLogs = () => {
    setIsLoading(true);
    const queryParams = {
      startDate: startDate,
      endDate: endDate,
      user: filterUser,
      action: filterAction,
      srNo: filterSRNo,
      token: token
    };

    Axios.get(`https://` + host + `/realapi/activity-logs`, { params: queryParams })
      .then((response) => {
        setActivityLogs(response.data);
        setFilteredLogs(response.data);
        setIsLoading(false);
      })
      .catch((error) => {
        console.error('Error fetching activity logs:', error);
        toast.error('Error loading activity logs');
        setIsLoading(false);
      });
  };

  // Fetch unique users for filter
  useEffect(() => {
    Axios.get(`https://` + host + `/realapi/get/Operators/${token}`)
      .then((data) => {
        setUsers(data.data);
      })
      .catch((error) => {
        console.error('Error fetching users:', error);
      });
  }, []);

  // Initial load
  useEffect(() => {
    fetchActivityLogs();
  }, []);

  // Apply filters
  const applyFilters = () => {
    fetchActivityLogs();
  };

  // Clear filters
  const clearFilters = () => {
    setStartDate(Date1.toISOString().slice(0, 10));
    setEndDate(Date1.toISOString().slice(0, 10));
    setFilterUser('');
    setFilterAction('');
    setFilterSRNo('');
    setTimeout(() => {
      fetchActivityLogs();
    }, 100);
  };

  // Toggle row expansion
  const toggleRowExpansion = (logId) => {
    setExpandedRows(prev => ({
      ...prev,
      [logId]: !prev[logId]
    }));
  };

  // Format JSON for display
  const formatJSON = (jsonString) => {
    if (!jsonString) return 'N/A';
    try {
      const parsed = JSON.parse(jsonString);
      return JSON.stringify(parsed, null, 2);
    } catch (e) {
      return jsonString;
    }
  };

  // Get changed fields as readable text
  const getChangedFieldsDisplay = (changedFields, oldValues, newValues) => {
    if (!changedFields) return 'N/A';

    try {
      const fields = JSON.parse(changedFields);
      const oldVals = oldValues ? JSON.parse(oldValues) : {};
      const newVals = newValues ? JSON.parse(newValues) : {};

      return fields.map(field => (
        <div key={field} style={{ marginBottom: '5px' }}>
          <strong>{field}:</strong>
          <span style={{ color: '#dc3545', marginLeft: '5px' }}>
            {oldVals[field] !== undefined ? String(oldVals[field]) : 'N/A'}
          </span>
          <span style={{ margin: '0 5px' }}>→</span>
          <span style={{ color: '#28a745' }}>
            {newVals[field] !== undefined ? String(newVals[field]) : 'N/A'}
          </span>
        </div>
      ));
    } catch (e) {
      return 'Error parsing changes';
    }
  };

  // Get action badge color
  const getActionBadgeClass = (action) => {
    switch (action) {
      case 'INSERT':
        return 'badge bg-success';
      case 'UPDATE':
        return 'badge bg-primary';
      case 'DELETE':
        return 'badge bg-danger';
      case 'SCHEDULE_CHANGE':
        return 'badge bg-warning';
      default:
        return 'badge bg-secondary';
    }
  };

  // Export to CSV
  const exportToCSV = () => {
    const headers = ['Log ID', 'Date/Time', 'Action', 'SR No', 'Changed By', 'Changed Fields'];
    const csvData = filteredLogs.map(log => [
      log.Log_ID,
      new Date(log.Change_DateTime).toLocaleString(),
      log.Action_Type,
      log.SR_No || 'N/A',
      log.Changed_By,
      log.Changed_Fields ? JSON.parse(log.Changed_Fields).join(', ') : 'N/A'
    ]);

    const csvContent = [
      headers.join(','),
      ...csvData.map(row => row.map(cell => `"${cell}"`).join(','))
    ].join('\n');

    const blob = new Blob([csvContent], { type: 'text/csv' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `activity_log_${new Date().toISOString().slice(0, 10)}.csv`;
    a.click();
  };

  return (
    <div className="MainPage_data">
      <ToastContainer />
      <div className="Container">
        <br />
        <h2 id="page-title">ACTIVITY LOG - PRODUCTION SCHEDULE</h2>
        <br />

        {/* Filter Section */}
        <div className="row" id="filter-row">
          <div className="col-md-2 col-sm-6 mb-3">
            <label><b>Start Date</b></label>
            <input
              type="date"
              className="form-control form-rounded"
              value={startDate}
              onChange={(e) => setStartDate(e.target.value)}
            />
          </div>

          <div className="col-md-2 col-sm-6 mb-3">
            <label><b>End Date</b></label>
            <input
              type="date"
              className="form-control form-rounded"
              value={endDate}
              onChange={(e) => setEndDate(e.target.value)}
            />
          </div>

          <div className="col-md-2 col-sm-6 mb-3">
            <label><b>User</b></label>
            <input
              type="text"
              className="form-control form-rounded"
              placeholder="Filter by user"
              list="userList"
              value={filterUser}
              onChange={(e) => setFilterUser(e.target.value)}
            />
            <datalist id="userList">
              <option value=""></option>
              {users.map(user => (
                <option key={user.Name} value={user.Name}>{user.Name}</option>
              ))}
            </datalist>
          </div>

          <div className="col-md-2 col-sm-6 mb-3">
            <label><b>Action Type</b></label>
            <select
              className="form-control form-rounded"
              value={filterAction}
              onChange={(e) => setFilterAction(e.target.value)}
            >
              <option value="">All Actions</option>
              <option value="INSERT">Insert</option>
              <option value="UPDATE">Update</option>
              <option value="DELETE">Delete</option>
              <option value="SCHEDULE_CHANGE">Schedule Change</option>
            </select>
          </div>

          <div className="col-md-2 col-sm-6 mb-3">
            <label><b>SR No</b></label>
            <input
              type="text"
              className="form-control form-rounded"
              placeholder="Filter by SR No"
              value={filterSRNo}
              onChange={(e) => setFilterSRNo(e.target.value)}
            />
          </div>

          <div className="col-md-2 col-sm-6 mb-3">
            <label><b>&nbsp;</b></label>
            <div>
              <button className="btn btn-primary btn-sm" onClick={applyFilters}>
                Apply Filters
              </button>
              <button className="btn btn-secondary btn-sm ms-2" onClick={clearFilters}>
                Clear
              </button>
            </div>
          </div>
        </div>

        {/* Action Buttons */}
        <div className="row mb-3">
          <div className="col-md-12">
            <button className="btn btn-success btn-sm" onClick={exportToCSV}>
              Export to CSV
            </button>
            <button className="btn btn-info btn-sm ms-2" onClick={fetchActivityLogs}>
              Refresh
            </button>
            <Link to="/Scheduling">
              <button className="btn btn-secondary btn-sm ms-2">
                Back to Scheduling
              </button>
            </Link>
          </div>
        </div>

        {/* Stats */}
        <div className="row mb-3">
          <div className="col-md-12">
            <div className="alert alert-info">
              <strong>Total Records:</strong> {filteredLogs.length}
            </div>
          </div>
        </div>

        {/* Activity Log Table */}
        <div id="Schedule_table">
          <table className="table table-bordered table-striped">
            <thead>
              <tr>
                <th style={{ width: '50px' }}>Log ID</th>
                <th style={{ width: '150px' }}>Date/Time</th>
                <th style={{ width: '100px' }}>Action</th>
                <th style={{ width: '80px' }}>SR No</th>
                <th style={{ width: '150px' }}>Changed By</th>
                <th>Changed Fields</th>
                <th style={{ width: '100px' }}>Details</th>
              </tr>
            </thead>
            <tbody>
              {filteredLogs.length === 0 ? (
                <tr>
                  <td colSpan="7" className="text-center">
                    No activity logs found
                  </td>
                </tr>
              ) : (
                filteredLogs.map((log) => (
                  <React.Fragment key={log.Log_ID}>
                    <tr>
                      <td>{log.Log_ID}</td>
                      <td>{new Date(log.Change_DateTime).toLocaleString()}</td>
                      <td>
                        <span className={getActionBadgeClass(log.Action_Type)}>
                          {log.Action_Type}
                        </span>
                      </td>
                      <td>{log.SR_No || 'N/A'}</td>
                      <td>{log.Changed_By}</td>
                      <td>
                        {log.Changed_Fields ? (
                          JSON.parse(log.Changed_Fields).join(', ')
                        ) : (
                          'N/A'
                        )}
                      </td>
                      <td>
                        <button
                          className="btn btn-sm btn-outline-primary"
                          onClick={() => toggleRowExpansion(log.Log_ID)}
                        >
                          {expandedRows[log.Log_ID] ? 'Hide' : 'Show'}
                        </button>
                      </td>
                    </tr>
                    {expandedRows[log.Log_ID] && (
                      <tr>
                        <td colSpan="7" style={{ backgroundColor: '#f8f9fa' }}>
                          <div className="p-3">
                            <div className="row">
                              <div className="col-md-6">
                                <h6>Changes:</h6>
                                <div style={{ fontSize: '0.9em' }}>
                                  {getChangedFieldsDisplay(
                                    log.Changed_Fields,
                                    log.Old_Values,
                                    log.New_Values
                                  )}
                                </div>
                              </div>
                              <div className="col-md-6">
                                <h6>Additional Information:</h6>
                                <div style={{ fontSize: '0.9em' }}>
                                  <p><strong>IP Address:</strong> {log.IP_Address || 'N/A'}</p>
                                  <p><strong>Notes:</strong> {log.Notes || 'N/A'}</p>
                                  {log.Action_Type === 'DELETE' && log.Old_Values && (
                                    <div>
                                      <h6 className="mt-2">Deleted Record:</h6>
                                      <pre style={{
                                        fontSize: '0.8em',
                                        backgroundColor: '#fff',
                                        padding: '10px',
                                        borderRadius: '5px',
                                        maxHeight: '200px',
                                        overflow: 'auto'
                                      }}>
                                        {formatJSON(log.Old_Values)}
                                      </pre>
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        </td>
                      </tr>
                    )}
                  </React.Fragment>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>

      {isLoading && (
        <div className='overlay'>
          <div className="text-center">
            <div className="spinner-border" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default ActivityLog;